import PageLayout from "components/layout/PageLayout";
import { useLazyGetAllHealthEventsQuery } from "./api/healthEventApi";
import { useEffect, useState } from "react";
import { HealthEventCalendar } from "./views/HealthEventsCalendar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HealthEvents = () => {

    const [t] = useTranslation(["health"])

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const navigate = useNavigate()

    const [fetchEvents, {
        data: healthEvents,
        isFetching: isFetching,
        isSuccess: isSuccess,
    }] = useLazyGetAllHealthEventsQuery();

    useEffect(() => {
        if (startDate && endDate)
            fetchEvents({ start: startDate, end: endDate }); // Ricarica i dati quando le date cambiano
    }, [startDate, endDate]);

    const handleMonthChange = (start, end) => {
        console.log("MonthChanged")
        setStartDate(new Date(start).getTime());
        setEndDate(new Date(end).getTime());
    };

    function handleEventClick(clickInfo) {
        navigate("/dashboard/health/history",
            {
                state: {
                    userGUID: clickInfo.event.extendedProps.eventDto.user.guid,
                    date: clickInfo.event.extendedProps.eventDto.timestamp,
                }
            }
        )
    }

    return (
        <PageLayout
            pageTitle={t("menu.events_log_ext")}
            isLoadingContent={isFetching}
            onPageRefresh={() => fetchEvents({ start: startDate, end: endDate })}
            bodyContent={


                <HealthEventCalendar
                    healthEvents={healthEvents}
                    onDataChange={handleMonthChange}
                    onEventClick={handleEventClick}
                />


            }
        />
    );
}

export default HealthEvents